import * as React from "react";
const BigStar = (props) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9149 1.44567L13.6894 4.99454C13.9285 5.48534 14.5703 5.95097 15.1114 6.05165L18.3205 6.58021C20.3718 6.91999 20.85 8.40498 19.3776 9.88997L16.8733 12.3943C16.458 12.8096 16.2189 13.6276 16.3573 14.2191L17.0746 17.3149C17.641 19.7563 16.3322 20.7128 14.1802 19.4291L11.1724 17.6421C10.6313 17.3149 9.72521 17.3149 9.18407 17.6421L6.17633 19.4291C4.02436 20.7002 2.71555 19.7563 3.28186 17.3149L3.99919 14.2191C4.11245 13.615 3.87334 12.797 3.45805 12.3817L0.953702 9.87739C-0.518703 8.40498 -0.0404858 6.91999 2.01081 6.56762L5.2199 6.03906C5.76104 5.95097 6.40286 5.47276 6.64197 4.98196L8.4164 1.43308C9.38542 -0.479786 10.9459 -0.479786 11.9149 1.44567Z"
      fill={props.fill}
    />
  </svg>
);
export default BigStar;
